import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Report } from '../../models/report.model';

@Component({
  selector: 'app-tendance-marche-immobilier',
  templateUrl: './tendance-marche-immobilier.component.html',
  styleUrls: ['./tendance-marche-immobilier.component.scss'],
})
export class TendanceMarcheImmobilierComponent implements OnChanges {
  @Input() tendencies!: Report.Tendencies;
  @Input() reportId!: string;
  @Input() isLoading = false;

  tendenciesInternal!: Report.Tendencies;

  @Output() tendenciesChanged = new EventEmitter<Report.Tendencies>();
  @Output() tendenciesEnabled = new EventEmitter<boolean>();
  @Output() cancled = new EventEmitter<void>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tendencies']?.currentValue) {
      this.tendenciesInternal = changes['tendencies'].currentValue;
    }
  }

  onTendenciesChanged(tendenciesInternal: Report.Tendencies): void {
    this.tendenciesInternal = tendenciesInternal;
  }

  onSaveSection(): void {
    this.tendenciesChanged.emit(this.tendenciesInternal);
  }

  onEnabled(isEnabled: boolean): void {
    this.tendenciesEnabled.emit(isEnabled);
  }

  onCancled(): void {
    this.cancled.emit();
  }
}
